import MuiTableBody, { TableBodyProps as MuiTableBodyProps } from '@material-ui/core/TableBody';

export type DSTableBodyProps = MuiTableBodyProps & { ['data-cy']?: string };

export const DSTableBody = MuiTableBody;
